import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import { useSelector } from 'react-redux';

import scribeTrack from 'scribe/scribe-track';
import { ADD_INSTRUCTION_POSITION } from 'scribe/constant';
import { inGrabApp } from 'common/utils/platform';
import instrumentationDuck from 'ducks/instrumentation-duck';
import FloatingBox from './floating-box';
import AddInstructionButton from '../button/add-instruction-button';

import styles from './add-instruction-box.less';

const AddInstructionBox = ({ coordinates, title, address, guid }) => {
  const { orderId, trackingPageType, trackingSource } = useSelector(
    instrumentationDuck.selectors.instrumentation,
  );

  const sendInstrumentation = useCallback(
    () => {
      scribeTrack.expressTracking.addInstruction({
        trackingSource,
        addInstructionPosition: ADD_INSTRUCTION_POSITION.MAP,
        orderIdDisplayed: orderId,
        isInApp: inGrabApp(),
        trackingPageType,
      });
    },
    [orderId, trackingPageType, trackingSource],
  );

  return (
    <FloatingBox coordinates={coordinates}>
      <div className={styles.container}>
        {title && <p className={styles.title}>{title}</p>}
        <AddInstructionButton
          entry={ADD_INSTRUCTION_POSITION.MAP}
          onClick={sendInstrumentation}
          buttonClassName={styles.linkButton}
          title={title}
          address={address}
          guid={guid}
        >
          {I18n.t('deliveryDetails.instructions.addInstructions')}
        </AddInstructionButton>
      </div>
    </FloatingBox>
  );
};

AddInstructionBox.propTypes = {
  coordinates: PropTypes.arrayOf(PropTypes.number).isRequired,
  title: PropTypes.string,
  address: PropTypes.string,
  guid: PropTypes.string,
};

AddInstructionBox.defaultProps = {
  title: '',
  address: '',
  guid: '',
};

export default AddInstructionBox;
